import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography as MUITypography } from '@material-ui/core';
import type { TypographyProps } from '@material-ui/core/Typography';
import classNames from 'classnames';

import type { KlpHeadingLevel, KlpStyled } from '../Theme';
import { removeKlpStyles, useKlpStyles } from '../Theme';

export enum HeadingMapping {
    DEFAULT = 'h2',
    ONE = 'h1',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    TWO = 'h2',
    THREE = 'h3',
    FOUR = 'h4',
    FIVE = 'h5',
    SIX = 'h6',
}

interface IOwnProps {
    translation?: string;
    translationOptions?: object;
    klpHeadingLevel?: KlpHeadingLevel;
}

export type IHeadingProps = IOwnProps & KlpStyled & TypographyProps;

export const Heading: React.FC<IHeadingProps> = ({
    children,
    className = '',
    klpHeadingLevel = 'TWO',
    translation,
    translationOptions,
    ...restProps
}) => {
    const styles = useKlpStyles(restProps);
    const { t } = useTranslation();
    return (
        <MUITypography
            variant={HeadingMapping[klpHeadingLevel]}
            className={classNames(styles.klpStyles, className)}
            {...removeKlpStyles(restProps)}
        >
            {translation ? t(translation, translationOptions) : children}
        </MUITypography>
    );
};

Heading.displayName = 'Heading';
